const productsData = [
  {
    id: 0,
    category: 'coats',
    brand: 'Filippa K',
    brandCheck: 'filippa',
    type: 'Hague Pea Coat',
    route: 'hague-pea-coat',
    color: 'Navyblue',
    hexColor: '#000080',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933285/images/coatfk_xmcwzp.jpg`,
    price: 370
  },
  {
    id: 1,
    category: 'coats',
    brand: 'Peak Performance',
    brandCheck: 'peak',
    type: 'Y Parka',
    route: 'y-parka',
    color: 'White',
    hexColor: '#FFF',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933286/images/peak-white_tzdrkl.jpg`,
    price: 550
  },
  {
    id: 2,
    category: 'coats',
    brand: 'J.Lindeberg',
    brandCheck: 'lindeberg',
    type: 'Holger Melton Rock',
    route: 'holger-melton-rock',
    color: 'Black',
    hexColor: '#000',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933286/images/lindeberg-black_dnsphp.jpg`,
    price: 380
  },
  {
    id: 3,
    category: 'coats',
    brand: 'Tiger of Sweden',
    brandCheck: 'tiger',
    type: 'Ossien Jacket',
    route: 'ossien-jacket',
    color: 'Dark Green',
    hexColor: '#4E4D30',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933286/images/tiger-green_qrebht.jpg`,
    price: 550
  },
  {
    id: 4,
    category: 'coats',
    brand: 'Peak Performance',
    brandCheck: 'peak',
    type: 'Rivel Vernis Jacket',
    route: 'rivel-vernis-jacket',
    color: 'Black',
    hexColor: '#000',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933286/images/peak-black_zl7dfo.jpg`,
    price: 400
  },
  {
    id: 5,
    category: 'coats',
    brand: 'Tiger of Sweden',
    brandCheck: 'tiger',
    type: 'Jacket',
    route: 'jacket',
    color: 'Beige',
    hexColor: '#C2936A',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933287/images/tiger-brown_xf7kbo.jpg`,
    price: 849
  },
  {
    id: 6,
    category: 'boots',
    brand: 'These Glory Days',
    brandCheck: 'glory',
    type: 'Chelsea Boot',
    route: 'chelsea-boot',
    color: 'Black',
    hexColor: '#000',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933285/images/black-boots_kqpegb.jpg`,
    price: 129
  },
  {
    id: 7,
    category: 'boots',
    brand: 'TGA',
    brandCheck: 'tga',
    type: 'Cap Toe Boot',
    route: 'cap-toe-boot',
    color: 'Brown',
    hexColor: '#4C2E25',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933284/images/brown-boots_m8ap13.jpg`,
    price: 159
  },
  {
    id: 8,
    category: 'boots',
    brand: 'TGA',
    brandCheck: 'tga',
    type: 'Chelsea Boot',
    route: 'chelsea-boot-2',
    color: 'Brown',
    hexColor: '#78321A',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933285/images/brown-boots2_fzidel.jpg`,
    price: 159
  },
  {
    id: 9,
    category: 'boots',
    brand: 'These Glory Days',
    brandCheck: 'glory',
    type: 'Collins Boot',
    route: 'collins-boot',
    color: 'Dark Brown',
    hexColor: '#514746',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933284/images/shiny-boots_vpxtzc.jpg`,
    price: 169
  },
  {
    id: 10,
    category: 'accessories',
    brand: 'These Glory Days',
    brandCheck: 'glory',
    type: 'Brunello Scarf',
    route: 'brunello-scarf',
    color: 'Green',
    hexColor: '#54674C',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933282/images/glory-green_s7n0hy.jpg`,
    price: 59
  },
  {
    id: 11,
    category: 'accessories',
    brand: 'These Glory Days',
    brandCheck: 'glory',
    type: 'Belluno Scarf',
    route: 'belluno-scarf',
    color: 'Grey',
    hexColor: '#46484D',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933288/images/glory-grey_xhltsk.jpg`,
    price: 59
  },
  {
    id: 12,
    category: 'accessories',
    brand: 'Lacoste',
    brandCheck: 'lacoste',
    type: 'Beanie',
    route: 'beanie',
    color: 'Navyblue',
    hexColor: '#282A3F',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933283/images/lacoste-blue_nt0awt.jpg`,
    price: 29
  },
  {
    id: 13,
    category: 'accessories',
    brand: 'Oscar Jacobson',
    brandCheck: 'oscar',
    type: 'Wool Scarf',
    route: 'wool-scarf',
    color: 'Brown',
    hexColor: '#62462A',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933284/images/oscar-checkered_tejoai.jpg`,
    price: 129
  },
  {
    id: 14,
    category: 'accessories',
    brand: 'Peak Performance',
    brandCheck: 'peak',
    type: 'Beanie',
    route: 'beanie-2',
    color: 'Dark Green',
    hexColor: '#1C2D26',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933284/images/peak-army_cpku9v.jpg`,
    price: 50
  },
  {
    id: 15,
    category: 'accessories',
    brand: 'Lyle & Scott',
    brandCheck: 'lyle',
    type: 'Scarf',
    route: 'scarf',
    color: 'Red',
    hexColor: '#592029',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933284/images/scott-red_od7vgo.jpg`,
    price: 169
  },
  {
    id: 16,
    category: 'accessories',
    brand: 'Tiger of Sweden',
    brandCheck: 'tiger',
    type: 'Hollein Beanie',
    route: 'hollein-beanie',
    color: 'Black',
    hexColor: '#000',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933282/images/tiger-black_mhqmva.jpg`,
    price: 79
  },
  {
    id: 17,
    category: 'accessories',
    brand: 'Tretorn',
    brandCheck: 'tretorn',
    type: 'Makia Beanie',
    route: 'makia-beanie',
    color: 'Yellow',
    hexColor: '#E4CA56',
    url: `https://res.cloudinary.com/duckpx7as/image/upload/v1580933283/images/tretorn-yellow_oxaiqj.jpg`,
    price: 50
  }
];

export default productsData;
